{
  "title": "如何建立與發布表單（報名表／作品繳交表單）",
  "description": "建立報名表單或作品繳交表單、新增欄位，並發布成正式版本供參賽者填寫。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，該表單有一個已發布的版本，參賽者可以依此版本填寫報名或作品繳交內容。",
  "roleNote": "主辦方管理員",
  "prerequisites": ["已具備該競賽的管理權限", "已規劃好需要蒐集的欄位內容"],
  "pathLabel": "主辦方主控台 → 競賽設定 → 表單",
  "steps": [
    {
      "title": "1. 建立表單並命名",
      "description": "選擇表單類型（報名表單／團隊表單／作品繳交表單／評審利益迴避表單）並輸入名稱；建立時必須自行輸入名稱，系統不會自動套用通用型別文字。"
    },
    {
      "title": "2. 新增欄位",
      "description": "依需要新增欄位，可選擇的類型包含短文字、長文字、數字、Email、日期、單選、多選、下拉選單、檔案上傳等；每個欄位可設定是否必填、預設值、驗證規則，以及依其他欄位的答案決定是否顯示（條件顯示）。也可以填寫選填的「所屬區塊」名稱，填入相同名稱的欄位會在參賽者端顯示為同一個區塊標題底下的一組欄位。必填的勾選框（例如「團隊聲明」）代表「必須勾選」：沒有勾選時，參賽者無法完成報名，伺服器也會拒絕。"
    },
    {
      "title": "3. 調整欄位順序（選填）",
      "description": "可用拖曳、鍵盤或上下移按鈕調整欄位順序，動作會立即反映於畫面；若儲存失敗，畫面會自動還原為原本順序並顯示錯誤訊息，請再試一次。"
    },
    {
      "title": "4. 預覽表單",
      "description": "新增完欄位後可預覽表單目前的樣子，確認欄位順序、必填標示與條件顯示邏輯符合預期。預覽是可以操作的：您可以直接選擇下拉選單或勾選項目，馬上看到條件顯示欄位在各種選擇下的呈現（例如選擇 A 組與 B 組時分別會出現哪些欄位），方便發布前逐一檢查各分支；預覽不會送出或儲存任何資料，檔案類欄位也無法在預覽中上傳。"
    },
    {
      "title": "5. 發布表單",
      "description": "確認無誤後點選「發布」，將目前的草稿版本正式生效；只有存在未發布的變更（草稿）時才能發布，沒有變更時發布會被拒絕。"
    }
  ],
  "afterward": [
    "表單狀態顯示已發布，參賽者可依此版本填寫",
    "已發布的版本內容不可再修改；若之後需要調整欄位，系統會在您下一次編輯時自動建立新的草稿版本，不影響目前已發布版本，也不影響既有已送出的答案",
    "已送出的答案永遠對應到當時填寫時所使用的表單版本，不會因為後續發布新版本而改變",
    "表單改版後，已完成報名的學生不會被退回；但若他們已儲存的答案不符合新版的必填規則（例如新增了必填欄位），會被標示為「需補填」，主辦方可在「報名資料」頁看到名單"
  ],
  "nextSteps": "報名表與作品繳交表單建立好後，請見「如何建立競賽輪次並設定時程」將表單綁定到對應輪次。",
  "faq": [
    {
      "q": "已發布的表單可以直接修改欄位嗎？",
      "a": "不行。已發布版本的內容是不可變的；當您開始編輯（新增／修改／刪除欄位）時，系統會自動把已發布版本複製成一份新的草稿，您接下來的變更都套用在這份草稿上，發布後才會正式生效，過程不需要您手動建立新版本。"
    },
    {
      "q": "報名表跟作品繳交表單是同一套建立方式嗎？",
      "a": "是的。系統提供的四種表單（報名表單、團隊表單、作品繳交表單、評審利益迴避表單）都使用同一套建立與版本化機制，差別只在於欄位內容與各自的用途。"
    },
    {
      "q": "為什麼我點選「發布」卻出現錯誤？",
      "a": "最常見的原因是目前沒有任何未發布的草稿變更可供發布；只有存在草稿版本時，發布動作才有意義。"
    },
    {
      "q": "調整欄位順序後畫面顯示「排序儲存失敗，已還原為原本順序，請再試一次。」是什麼意思？",
      "a": "代表這次順序調整沒有成功儲存到伺服器，畫面已自動還原為調整前的順序，不會有順序不一致的風險；請重新嘗試一次拖曳或上下移。若目前編輯的是已發布版本，系統會先自動建立新草稿版本再套用排序，這與新增或刪除欄位時的自動建立草稿規則相同。"
    }
  ]
}
